import React from 'react'
import { Link } from 'react-router-dom'
import { ArrowRight } from 'lucide-react'

import { buildExplorePath } from '@/config/explore'
import { COMMAND_PALETTE_ENABLED } from '@/config/platformFeatures'
import { useTranslation } from '@/features/locale/LocaleProvider'
import { cn } from '@/lib/utils'

export function HomeHero() {
  const t = useTranslation()

  return (
    <section
      className={cn(
        'mobile-app__detail-hero-card browse-home-hero relative overflow-hidden',
        'px-6 sm:px-10 md:px-10',
      )}
    >
      <svg
        className="browse-home-hero__decor pointer-events-none opacity-30"
        viewBox="0 0 1400 800"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
      >
        <path
          d="M0 680 Q350 620 700 690 T1400 650"
          stroke="currentColor"
          strokeWidth="2.5"
          className="text-primary/45"
          strokeLinecap="round"
        />
        <path
          d="M0 730 Q400 670 750 735 T1400 700"
          stroke="currentColor"
          strokeWidth="1.25"
          className="text-primary/20"
          strokeLinecap="round"
        />
        <circle cx="120" cy="140" r="72" fill="currentColor" className="text-primary/10" />
        <circle cx="1280" cy="620" r="88" fill="currentColor" className="text-primary/8" />
        <circle cx="980" cy="120" r="34" fill="currentColor" className="text-primary/12" />
        <circle cx="260" cy="680" r="48" fill="currentColor" className="text-primary/14" />
      </svg>

      <div className="browse-home-hero__inner relative z-10">
        <div className="browse-home-hero__masthead">
          <h1 className="browse-home-hero__title">DON&apos;T PANIC</h1>
          <div className="browse-home-hero__subtitle-wrap">
            <p className="browse-home-hero__subtitle">{t.home.subtitle}</p>
          </div>
        </div>

        <p className="browse-home-hero__lead">{t.home.lead}</p>

        <div className="browse-home-hero__footer">
          <div className="browse-home-hero__actions">
            <Link to="/swap" className="mobile-app__detail-action mobile-app__detail-action--primary">
              {t.home.tryNutrimatic}
            </Link>
            <Link to="/about" className="mobile-app__detail-action">
              {t.home.whatIsDontPanic}
            </Link>
            <Link to={buildExplorePath('pools')} className="mobile-app__detail-action">
              {t.home.exploreEcosystem}
              <ArrowRight className="size-4" aria-hidden />
            </Link>
          </div>

          {COMMAND_PALETTE_ENABLED ? (
            <p className="mobile-app__caption hidden pt-4 sm:block">{t.brand.commandPaletteHint}</p>
          ) : null}
        </div>
      </div>
    </section>
  )
}
